import React from 'react';
import { Code, Smartphone, Gamepad2 } from 'lucide-react';
import { useExperience } from '../../../context/ExperienceContext';
const AboutImage = () => {
  const { yearsOfExperience } = useExperience();

  return (
    <div className="flex justify-center lg:justify-start">
      <div className="relative">
        {/* Main Image Container */}
        <div className="relative w-80 h-96 md:w-96 md:h-[28rem]">
          {/* Background Decorations */}
          <div className="absolute -top-4 -left-4 w-full h-full bg-gradient-to-br from-blue-400 to-purple-500 rounded-2xl transform rotate-3"></div>
          <div className="absolute -top-2 -left-2 w-full h-full bg-gradient-to-br from-purple-400 to-pink-500 rounded-2xl transform rotate-1"></div>
          
          {/* Main Image */}
          <div className="relative w-full h-full bg-white dark:bg-gray-800 rounded-2xl overflow-hidden border-4 border-white dark:border-gray-700 shadow-2xl">
            <img 
              src="/images/about-photo.jpg" // You can add a different photo here
              alt="Anie Joseph Cabahug working"
              className="w-full h-full object-cover"
              onError={(e) => {
                // Fallback if image doesn't load
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            
            {/* Fallback content */}
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600 text-white" style={{ display: 'none' }}>
              <div className="text-center">
                <div className="text-8xl mb-4">👨‍💻</div>
                <div className="text-xl font-semibold">Anie Joseph</div>
                <div className="text-lg">Full Stack Developer</div>
              </div>
            </div>
          </div>
          
          {/* Floating Elements */}
          <div className="absolute -top-6 -right-6 bg-yellow-400 text-black px-3 py-2 rounded-lg text-sm font-semibold shadow-lg animate-bounce">
            {yearsOfExperience.displayText} Years
          </div>
          <div className="absolute -bottom-6 -left-6 bg-green-500 text-white px-3 py-2 rounded-lg text-sm font-semibold shadow-lg animate-bounce" style={{ animationDelay: '0.5s' }}>
            BS IT Graduate
          </div>
          <div className="absolute top-1/2 -right-8 bg-purple-500 text-white px-2 py-1 rounded text-xs font-semibold shadow-lg animate-bounce" style={{ animationDelay: '1s' }}>
            🎮 Games
          </div>
        </div>

        {/* Tech Icons Floating Around */}
        <div className="absolute top-20 -left-12 bg-blue-500 p-2 rounded-full shadow-lg animate-float">
          <Code className="w-5 h-5 text-white" />
        </div>
        <div className="absolute bottom-32 -right-12 bg-green-500 p-2 rounded-full shadow-lg animate-float" style={{ animationDelay: '1s' }}>
          <Smartphone className="w-5 h-5 text-white" />
        </div>
        <div className="absolute top-1/3 -left-8 bg-purple-500 p-2 rounded-full shadow-lg animate-float" style={{ animationDelay: '2s' }}>
          <Gamepad2 className="w-5 h-5 text-white" />
        </div>
      </div>
    </div>
  );
};

export default AboutImage;